module.exports = __webpack_public_path__ + "static/media/Construction.a8679b18.png";